// src/Pages/ProfileReviewResult/ProfileReviewResult.jsx
import React from "react";
import { Helmet } from "@dr.pogodin/react-helmet";
import { useLocation, useSearchParams } from "react-router-dom";

function useVariant() {
  const { pathname } = useLocation();
  if (/(\/profiili\/hyvaksytty)(\/)?$/i.test(pathname)) return "approved";
  if (/(\/profiili\/hylatty)(\/)?$/i.test(pathname)) return "rejected";
  return "error";
}

export default function ProfileReviewResult() {
  const variant = useVariant();
  const [params] = useSearchParams();

  const bandName = params.get("band") || "";
  const slug     = params.get("slug") || "";   // voidaan näyttää metatietona, ei linkitetä
  const reason   = params.get("reason") || "";

  const isApproved = variant === "approved";
  const isRejected = variant === "rejected";

  const title =
    isApproved ? "Profiili julkaistu"
    : isRejected ? "Profiilin julkaisu hylätty"
    : "Linkissä ongelma";

  const intro =
    isApproved
      ? "Profiili on hyväksytty ja julkaistu."
      : isRejected
      ? "Profiilia ei julkaistu tällä erää. Alla mahdollinen syy."
      : "Tämä linkki on virheellinen tai vanhentunut.";

  return (
    <>
      <Helmet>
        <title>{title} – Buukkeri</title>
        <meta name="description" content={intro} />
      </Helmet>

      <main className="relative w-full min-h-[60vh] pb-16 mt-24">
        <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8">
          <section
            className="rounded-2xl ring-1 backdrop-blur-md shadow-xl
                       bg-[#0c0c12]/70 ring-white/10 text-white"
            aria-labelledby="profile-review-result-title"
          >
            <div className="p-6 sm:p-8">
              <h1 id="profile-review-result-title" className="text-2xl sm:text-3xl font-extrabold text-teal-300">
                {title}
              </h1>

              {(bandName || slug) && (
                <p className="mt-1 text-sm text-white/70">
                  {bandName && <>Esiintyjä: <span className="text-white">{bandName}</span></>}
                  {bandName && slug ? " · " : ""}
                  {slug && <>Slug: <span className="text-white">{slug}</span></>}
                </p>
              )}

              <p className="mt-3 text-base sm:text-lg text-white/85">{intro}</p>

              {isRejected && reason && (
                <div className="mt-6 rounded-xl border border-rose-400/30 bg-rose-950/30 p-4 text-sm sm:text-base">
                  <p><strong>Syy:</strong> {reason}</p>
                </div>
              )}

              {/* Ei CTA-linkkejä ylläpidon näkymässä */}

              <div className="mt-6 rounded-xl border border-white/10 bg-white/5 p-4 sm:p-5 text-sm sm:text-base text-white/80">
                <p>
                  Tarvitsetko apua?{" "}
                  <a href="mailto:info@buukkeri.com" className="underline">info@buukkeri.com</a>{" "}
                  tai{" "}
                  <a href="tel:+358443519265" className="underline">044 351 9265</a>.
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
